/**
 * Foundation · Timesheet — adattatore tra il modello giornata e la funzione Foundation "Copia da…".
 * withJustifications=false copia solo gli orari (scelta predefinita).
 */
import { planCopy, resolveTargets } from "@/foundation/copy";
import { isDayEmpty } from "./timeCore";

const norm = (d, withJ) => JSON.stringify({
  iv: (d?.intervals || []).filter((iv) => (iv.start || "").trim() || (iv.end || "").trim()).map((iv) => [iv.start, iv.end]),
  j: withJ ? (d?.justifications || []).map((j) => [j.cause, j.minutes]) : [],
});
const emptyFor = (withJ) => (d) => (withJ ? isDayEmpty(d) : norm(d, false) === norm({}, false));

export function planTimesheetCopy({ days, sourceDays, scope, mapDate, overwrite, withJustifications, cascade, conflictOf }) {
  const target = Object.fromEntries(days.map((d) => [d.date, d]));
  const source = Object.fromEntries((sourceDays || days).map((d) => [d.date, d]));
  const plan = planCopy({
    targets: resolveTargets(days.map((d) => d.date), scope),
    mapDate, overwrite, cascade, conflictOf,
    readSource: (date) => source[date],
    readTarget: (date) => target[date],
    isEmpty: emptyFor(withJustifications),
    isEqual: (a, b) => norm(a, withJustifications) === norm(b, withJustifications),
  });
  return { ...plan, withJustifications: !!withJustifications };
}

export function applyTimesheetCopy(days, plan, count) {
  const byDate = Object.fromEntries(plan.changes.map((c) => [c.target, c.value]));
  return days.map((d) => {
    const src = byDate[d.date];
    if (!src) return d;
    const intervals = src.intervals.map((iv) => ({ start: iv.start || "", end: iv.end || "" }));
    while (intervals.length < count) intervals.push({ start: "", end: "" });
    return { ...d, intervals, justifications: plan.withJustifications ? (src.justifications || []).map((j) => ({ ...j })) : d.justifications };
  });
}
